import React, { useState } from 'react';
import ImageWrapper from 'components/ImageWrapper';
import { useTranslation } from 'next-i18next';

interface Props {
  files: any;
}

const ChangelogImage = (props: Props) => {
  const { files } = props;
  const [isImageOpen, setIsImageOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const onImageClick = () => {
    setIsImageOpen(prev => !prev);
  };

  if (files.length === 0) {
    return null;
  }

  return (
    <>
      <div className="changelog-image" onClick={onImageClick}>
        <ImageWrapper
          src={files[0].miniaturePath}
          layout="fill"
          className="custom-img"
          unoptimized={true}
          alt={t('changelog.image.alt')}
        />
      </div>
      {isImageOpen && (
        <div className="changelog-image__view-box" onClick={onImageClick}>
          <div className="changelog-image__view-box-content">
            <ImageWrapper
              src={files[0].path}
              layout="fill"
              objectFit="contain"
              unoptimized={true}
              alt={t('changelog.image.alt')}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ChangelogImage;
